import { combineReducers } from 'redux';
import { authorizationApi } from './services/authorization/api';
import auth from './services/authorization/slices';
import { graphqlApi } from './services/graphql/api';
import userDetailsSlice from './services/graphql/slices/user-details';
import userPool from './services/graphql/slices/user-pool';
import devUsers from './services/graphql/slices/dev-users';

export default combineReducers({
  [authorizationApi.reducerPath]: authorizationApi.reducer,
  [graphqlApi.reducerPath]: graphqlApi.reducer,
  authentication: auth,
  userDetailsSlice,
  userPool,
  devUsers,
});
